import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box, Paper, Chip, IconButton,
} from '@mui/material';
import { Delete as DeleteIcon, Send as SendIcon } from '@mui/icons-material';

const CommentsDialog = ({
  open, onClose, selectedItem, comments, newComment,
  onNewCommentChange, onAddComment, onDeleteComment, user,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
  >
    <DialogTitle>Comments: {selectedItem?.title}</DialogTitle>
    <DialogContent>
      {comments.length === 0 ? (
        <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
          No comments yet. Be the first to comment!
        </Typography>
      ) : (
        <Box sx={{ mb: 3 }}>
          {comments.map((comment) => (
            <Paper
              key={comment.id}
              variant="outlined"
              sx={{
                p: 2, mb: 2, borderLeft: 4,
                borderLeftColor:
                  comment.role === 'admin' ? 'error.main' :
                  comment.role === 'contractor' ? 'primary.main' :
                  'secondary.main',
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                <Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="subtitle2" fontWeight="bold">
                      {comment.first_name} {comment.last_name}
                    </Typography>
                    <Chip
                      label={comment.role}
                      size="small"
                      color={
                        comment.role === 'admin' ? 'error' :
                        comment.role === 'contractor' ? 'primary' :
                        'secondary'
                      }
                    />
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                    {new Date(comment.created_at).toLocaleString()}
                  </Typography>
                </Box>
                {(comment.user_id === user.id || user.role === 'admin') && (
                  <IconButton size="small" color="error" onClick={() => onDeleteComment(comment.id)} aria-label="Delete comment">
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
              <Typography variant="body1" sx={{ mt: 1 }}>
                {comment.comment}
              </Typography>
            </Paper>
          ))}
        </Box>
      )}

      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle2" gutterBottom>Add a Comment</Typography>
        <Box display="flex" gap={1}>
          <TextField
            fullWidth
            multiline
            rows={2}
            variant="outlined"
            label="Add a comment"
            placeholder="Ask a question or leave a note..."
            value={newComment}
            onChange={(e) => onNewCommentChange(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && e.ctrlKey) onAddComment();
            }}
          />
          <Button
            variant="contained"
            color="primary"
            startIcon={<SendIcon />}
            onClick={onAddComment}
            disabled={!newComment.trim()}
            sx={{ height: 'fit-content', textTransform: 'none' }}
          >
            Send
          </Button>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          Press Ctrl+Enter to send
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default CommentsDialog;
